"use client";

import React from "react";
import { ContactMethodActions } from "@/components/shared/ContactMethodActions/ContactMethodActions";
import type { ContactMethodEntityContext } from "@/lib/utils/crm/contact-method-context";

export const HeaderFieldItem = ({
  icon: Icon,
  label,
  value,
  isEmail,
  isPhone,
  entityContext,
}: {
  icon: React.ElementType;
  label?: string;
  value: string;
  isEmail?: boolean;
  isPhone?: boolean;
  entityContext?: ContactMethodEntityContext;
}) => (
  <div className={`flex items-center gap-1 ${isEmail ? "min-w-0" : ""}`}>
    <Icon className="h-4 w-4 flex-shrink-0" />
    {isEmail ? (
      <ContactMethodActions
        kind="email"
        value={value}
        entityContext={entityContext}
      />
    ) : isPhone ? (
      <ContactMethodActions
        kind="phone"
        value={value}
        entityContext={entityContext}
      />
    ) : (
      <span>{value}</span>
    )}
  </div>
);
